import { render } from "./VersionChatRDG.vue?vue&type=template&id=680ea6ce"
import script from "./VersionChatRDG.vue?vue&type=script&lang=js"
export * from "./VersionChatRDG.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__